import styled, {keyframes} from "styled-components";
import Theme from "../../Styles/Themes";
import config from '../../Config/config.json';
import SVG from "react-inlinesvg";

const scrollAnimation = keyframes`
    0% {
        transform: translateX(20);
    }
    100% {
        transform: translateX(-100%);
    }
`;

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
`;

export const ContainerInput = styled.div`
    display: flex;
    width: 100%;
    border:  ${props => props.$isvalid ? '2px solid'+props.$borderColor : '2px solid #FF3939'};
    border-radius: 10px;
    padding: 2px 12px 2px 12px;
    justify-content: center;
    align-items: center;
`;

export const TextInput = styled.input`
    display: flex;
    width: 100%;
    background: transparent;
    color: #006560;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    font-style: normal;
    font-weight: 400;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    padding: 10px 8px 10px 15px;
    border: none;
    outline: none;
    @media (min-width: 720px) {
        padding: 17px 12px 19px 24px;
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    }
    @media (orientation: landscape) and (max-width: 1080px){
        padding: 1px 10px 1px 15px;
        font-size: ${Theme[config.theme].font.labels['small'].size};
    }
`;

export const InvalidText = styled.label`
    display: flex;
    width: 88%;
    color: #FF3939;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    visibility: ${props => props.$visibility? 'hidden' : 'visible'};
`;

export const ShowButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background: transparent;
    padding-inline: 15px;
    cursor: pointer;
    transition: 1s;
`;

export const ImageIcons = styled(SVG)`
    width: 24px;
    height: 24px;
    & path {
        fill: ${({ color }) => color};
    }
`;

export const Eye = styled(SVG)`
    & path {
        fill: ${({ color }) => color};
    }
`;

export const InvalidInfoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    border-radius: 7.304px;
    background: #FFF;
    box-shadow: 0px 2.221px 2.221px 0px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-height: 27px;
    &::-webkit-scrollbar {
        height : 3px;
        width: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const InvalidInfo = styled.div`
    white-space: nowrap;
    width: max-content;
    color: #FF3939;
    width: 70%;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    animation: ${scrollAnimation} 10s linear infinite;
`;